export const environment = {
    production: false,
    env: 'staging',
    config: {
        appName: 'Primăria Sectorului 4',
        appDescription: 'Portal Operator',
        fromTokenValid:
            'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-staging-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-operator', // here we find key for predefined local storage for app functionalities
        copyrightText:
            'Copyright © Primăria Sectorului 4 București <br/>2018 - 2026',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Succes',
                error: 'Atenție',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rău, dar am întâmpinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de Suport Tehnic.',
                fileErrorMsg:
                    'Ne pare rău, dar fișierul selectat nu a putut fi încărcat. Vă rugăm să reîncercați!',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://development.auth-core.webproductionlabs.com/',
        linkRedirectAuth: 'https://development.app.webproductionlabs.com/',
        clientId: 1,
        moduleId: 1,
        notifications: {
            authNotifications: 'api/nomenclatoare/user/auth-notifications',
        },
        user: {
            // PLATFORM USER MECHANISM
            loginUrl: 'api/login',
            logoutUrl: 'api/logout',
            getUserDetails: 'api/user',
            changeUserPassforce: 'api/user/update-password',
            generateShortToken: 'api/generateShortToken/',
        },
        gallery: {
            uploadImage: 'api/gallery/upload-image',
            listGallery: 'api/gallery/list-gallery',
            deleteImage: 'api/gallery/delete-image/',
        },
        destinations: {
            // urbanismPath: 'http://localhost:4200',
            urbanismPath: 'https://development.urb-app.webproductionlabs.com',
            platiOperatorPath: 'http://development.pay.webproductionlabs.com',
            indocOperatorPath: 'http://development.indoc.webproductionlabs.com',
            dgitlOperatorPath: 'http://development.dgitl.webproductionlabs.com',
            autorizariComercialeOperatorPath: 'http://development.autcom.webproductionlabs.com',
            monitorizareOperatorPath: 'https://development.monit.webproductionlabs.com',
            depsOperatorPath: 'https://development.deps.webproductionlabs.com',
            dgaspcOperatorPath: 'https://development.dgaspc.webproductionlabs.com',
            // dgaspcOperatorCentrePath: 'https://development.dgaspc.webproductionlabs.com',
        },
        bulevart: {
            gallery: {
                list: 'api/bulevart/list-bulevart-gallery',
                listDT: 'api/bulevart/list-dt-bulevart-gallery',
                uploadImage: 'api/bulevart/upload-bulevart-image',
                saveImage: 'api/bulevart/save-bulevart-image',
                updateImage: 'api/bulevart/update-bulevart-image', // id in payload
                delete: 'api/bulevart/delete/', // + id
                active: 'api/bulevart/toggle-active/', // + id
                public: 'api/bulevart/toggle-public/', // + id
                moveUp: 'api/bulevart/move-up/', // + id
                moveDown: 'api/bulevart/move-down/', // + id
            },
            nomenclatoare: {
                categorii: {
                    list: 'api/bulevart/nomenclator/categories/list',
                    listDT: 'api/bulevart/nomenclator/categories/list-dt',
                    listActive: 'api/bulevart/nomenclator/categories/list-active',
                    listPublic: 'api/bulevart/nomenclator/categories/list-public',
                    find: 'api/bulevart/nomenclator/categories/find/', // + id
                    store: 'api/bulevart/nomenclator/categories/store',
                    update: 'api/bulevart/nomenclator/categories/update',  // id in payload
                    delete: 'api/bulevart/nomenclator/categories/delete/', // + id
                    active: 'api/bulevart/nomenclator/categories/toggle-active/', // + id
                    public: 'api/bulevart/nomenclator/categories/toggle-public/', // + id
                    moveUp: 'api/bulevart/nomenclator/categories/move-up/', // + id
                    moveDown: 'api/bulevart/nomenclator/categories/move-down/', // + id
                },
                subcategorii: {
                    list: 'api/bulevart/nomenclator/subcategories/list',
                    listDT: 'api/bulevart/nomenclator/subcategories/list-dt',
                    listActive: 'api/bulevart/nomenclator/subcategories/list-active',
                    listPublic: 'api/bulevart/nomenclator/subcategories/list-public',
                    listByCategory: 'api/bulevart/nomenclator/subcategories/list-by-category/', // + id
                    find: 'api/bulevart/nomenclator/subcategories/find/', // + id
                    store: 'api/bulevart/nomenclator/subcategories/store',
                    update: 'api/bulevart/nomenclator/subcategories/update',  // id in payload
                    delete: 'api/bulevart/nomenclator/subcategories/delete/', // + id
                    active: 'api/bulevart/nomenclator/subcategories/toggle-active/', // + id
                    public: 'api/bulevart/nomenclator/subcategories/toggle-public/', // + id
                    moveUp: 'api/bulevart/nomenclator/subcategories/move-up/', // + id
                    moveDown: 'api/bulevart/nomenclator/subcategories/move-down/', // + id
                },
                categoriiTertiare: {
                    list: 'api/bulevart/nomenclator/tertiary-categories/list',
                    listDT: 'api/bulevart/nomenclator/tertiary-categories/list-dt',
                    listActive: 'api/bulevart/nomenclator/tertiary-categories/list-active',
                    listPublic: 'api/bulevart/nomenclator/tertiary-categories/list-public',
                    listBySubcategory: 'api/bulevart/nomenclator/tertiary-categories/list-by-subcategory/', // + id
                    find: 'api/bulevart/nomenclator/tertiary-categories/find/', // + id
                    store: 'api/bulevart/nomenclator/tertiary-categories/store',
                    update: 'api/bulevart/nomenclator/tertiary-categories/update',  // id in payload
                    delete: 'api/bulevart/nomenclator/tertiary-categories/delete/', // + id
                    active: 'api/bulevart/nomenclator/tertiary-categories/toggle-active/', // + id
                    public: 'api/bulevart/nomenclator/tertiary-categories/toggle-public/', // + id
                    moveUp: 'api/bulevart/nomenclator/tertiary-categories/move-up/', // + id
                    moveDown: 'api/bulevart/nomenclator/tertiary-categories/move-down/', // + id
                },
            },
        },
        platform: {
            app: {
                settings: {
                    // PLATFORM CONFIGURATIONS
                    configurations: {
                        getConfigurations: 'api/app/settings/configuration/list',
                        getSlugConfiguration: 'api/app/settings/configuration/find/', // + slug
                        getConfiguration: 'api/app/settings/configuration/one/', // + id
                        putConfiguration: 'api/app/settings/configuration/update', // id in payload
                        storeConfiguration: 'api/app/settings/configuration/store',
                        deleteConfiguration: 'api/app/settings/configuration/delete/', // id in payload
                        getConfigurationsDT: 'api/app/settings/configuration/list-dt',
                    },
                    modules: {
                        getModules: 'api/app/settings/module/list',
                        getModulesActive: 'api/app/settings/module/list/active',
                        getModulesPublic: 'api/app/settings/module/list/public',
                        getModule: 'api/app/settings/module/find/', // + id
                        putModule: 'api/app/settings/module/update', // id in payload
                        storeModule: 'api/app/settings/module/store',
                        deleteModule: 'api/app/settings/module/delete/', // id in payload
                        getModulesDT: 'api/app/settings/module/list-dt',
                        changeStatusModuleActive: 'api/app/settings/module/active/', // + id
                        changeStatusModulePublic: 'api/app/settings/module/public/', // + id
                    },
                    modulePermission: {
                        getModulePermissions: 'api/app/settings/module-permission/list',
                        getModulePermission: 'api/app/settings/module-permission/find/', // + id
                        putModulePermission: 'api/app/settings/module-permission/update', // id in payload
                        storeModulePermission: 'api/app/settings/module-permission/store',
                        deleteModulePermission:
                            'api/app/settings/module-permission/delete/', // id in payload
                        getModulePermissionsDT:
                            'api/app/settings/module-permission/list-dt',
                        getPermissionsAuthLib:
                            'api/app/settings/module-permission/getPermissionsAuthLib/', // + id
                        getPermissionsByModuleId:
                            'api/app/settings/module-permission/listPermissionsByModule/', // + id
                    },
                    moduleGroupPermission: {
                        getModuleGroupPermissions:
                            'api/app/settings/module-group-permission/list',
                        getModuleGroupPermissionsRoot:
                            'api/app/settings/module-group-permission/list/root',
                        getModuleGroupPermission:
                            'api/app/settings/module-group-permission/find/', // + id
                        putModuleGroupPermission:
                            'api/app/settings/module-group-permission/update', // id in payload
                        storeModuleGroupPermission:
                            'api/app/settings/module-group-permission/store',
                        deleteModuleGroupPermission:
                            'api/app/settings/module-group-permission/delete/', // id in payload
                        getModuleGroupPermissionsDT:
                            'api/app/settings/module-group-permission/list-dt',
                    },
                    moduleGroupPermissionAssigned: {
                        getModuleGroupPermissionAssignedDT:
                            'api/app/settings/module-group-permission/assigned/list-dt',
                        storeModuleGroupPermissionAssigned:
                            'api/app/settings/module-group-permission/assigned/store',
                        updateModuleGroupPermissionAssigned:
                            'api/app/settings/module-group-permission/assigned/update',
                        deleteModuleGroupPermissionAssigned:
                            'api/app/settings/module-group-permission/assigned/delete/', // + id
                    },
                },
            },
            dmu: {
                // OLD APPLICATION, DMU, WILL BE REMOVED IN THE FEATURE
                settings: {
                    configurations: {
                        getConfigurations: 'api/settings/configurations/list',
                        getConfigurationsDT: 'api/settings/configurations/list-dt',
                        getSlugConfiguration: 'api/settings/configuration/find/', // + slug
                        getConfiguration: 'api/settings/configuration/one/', // + id
                        putConfiguration: 'api/settings/configuration/update', // id in payload
                        storeConfiguration: 'api/settings/configurations/store',
                    },
                },
            },
            nomenclatoare: {
                // nomenclatoare for the platform
                passwords: {
                    changePassword: 'api/nomenclatoare/user/change-password',
                },
                user: {
                    storeUser: 'api/register',
                    getUsers: 'api/nomenclatoare/user/list',
                    getUserTypeActive: 'api/nomenclatoare/user-type/list-active',
                    getUsersDT: 'api/nomenclatoare/user/list-dt',
                    getUsersActive: 'api/nomenclatoare/user/list/active',
                    getUsersPublic: 'api/nomenclatoare/user/list/public',
                    getUser: 'api/nomenclatoare/user/find/', // + id
                    updateUser: 'api/nomenclatoare/user/update',
                    changeStatusUserActive: 'api/nomenclatoare/user/active/', // + id
                    changeStatusUserPublic: 'api/nomenclatoare/user/public/', // + id
                    resetPasswordAdmin: 'api/nomenclatoare/user/reset-password/', // + id
                    getActiveUsersByOrganigrama:
                        'api/nomenclatoare/user/list-users-organigrama',
                },
                cereri: {
                    getCereriList: 'api/nomenclatoare/cerere/list',
                    getCereriListDT: 'api/nomenclatoare/cerere/list-dt',
                    storeCereri: 'api/nomenclatoare/cerere/store',
                    updateCereri: 'api/nomenclatoare/cerere/update',
                    deleteCereri: 'api/nomenclatoare/cerere/delete/', // + id
                    getInfoDocList:
                        'api/nomenclatoare/cerere/getInformationsDocumentsList/', // + id
                    validateCerere: 'api/nomenclatoare/cerere/validateCerere/', // + id
                    invalidateCerere: 'api/nomenclatoare/cerere/invalidateCerere', // id in payload
                    cancellationCerere: 'api/nomenclatoare/cerere/cancellationCerere', // id in payload
                    postMessage: 'api/nomenclatoare/cerere/post-message', // id in payload
                    rePostMessage: 'api/nomenclatoare/cerere/re-post-message/', // + id
                    updatePriority: 'api/nomenclatoare/cerere/update-priority', // id in payload
                    updateStatus: 'api/nomenclatoare/cerere/update-status', // id in payload
                    updateAssignee: 'api/nomenclatoare/cerere/update-assignee', // id in payload
                    preluareCerere: 'api/nomenclatoare/cerere/preluare-cerere/', // + id
                    massUpdateStatus: 'api/nomenclatoare/cerere/mass-update-status',
                    massAssign: 'api/nomenclatoare/cerere/mass-assign',
                    massUpdatePriority: 'api/nomenclatoare/cerere/mass-update-priority',
                    uploadFileRegister: 'api/upload-file-register',
                    uploadFileRegisterBase64: 'api/upload-file-register-base64',
                    getDocument: 'api/nomenclatoare/cerere/document/', // + id,
                    numarRegistratura: 'api/nomenclatoare/cerere/generateRegNumber/',
                    exportHistory: 'api/nomenclatoare/cerere/download-history/', //+ id_cerere + user type (2=> ceteatan, 1=> operator)

                    updatePhoneNumberSolicitare: 'api/nomenclatoare/cerere/updatePhoneNumberSolicitare/', // + id_cerere + international_number payload

                    resetValidareCerere: 'api/nomenclatoare/cerere/reset/validare/', // id_cerere - PUT
                    resetinValidareCerere: 'api/nomenclatoare/cerere/reset/invalidare/', // id_cerere - PUT
                    resetClasareCerere: 'api/nomenclatoare/cerere/reset/clasare/', // id_cerere - PUT
                    resetInchidereCerere: 'api/nomenclatoare/cerere/reset/finalizare/', // id_cerere - POST
                },
                cereriHistory: {
                    getCereriHistoryList: 'api/nomenclatoare/cerere-history/list',
                    getCereriHistoryListDT: 'api/nomenclatoare/cerere-history/list-dt',
                    storeCerereHistory: 'api/nomenclatoare/cerere-history/store',
                    updateCerereHistory: 'api/nomenclatoare/cerere-history/update',
                    deleteCerereHistory: 'api/nomenclatoare/cerere-history/delete/', // + id
                    getCerereHistoryByCerereId:
                        'api/nomenclatoare/cerere-history/getCerereHistoryByCerereId/', // + id
                },
                source: {
                    getSurseDT: 'api/app/settings/source/list-dt',
                    getSurse: 'api/app/settings/source/list',
                    storeSurse: 'api/app/settings/source/store',
                    updateSurse: 'api/app/settings/source/update',
                    deleteSurse: 'api/app/settings/source/delete/',
                },
                userType: {
                    getUserTypes: 'api/nomenclatoare/user-type/list',
                    getUserTypesDT: 'api/nomenclatoare/user-type/list-dt',
                    storeUserTypes: 'api/nomenclatoare/user-type/store',
                    getUserTypeActive: 'api/nomenclatoare/user-type/list-active',
                    getUserType: 'api/nomenclatoare/user-type/find/', // + id
                    updateUserType: 'api/nomenclatoare/user-type/update',
                    changeStatusUserTypeActive: 'api/nomenclatoare/user-type/setActive/', // + id
                },
                permissions: {
                    getUserPermissions: 'api/nomenclatoare/permission/list',
                    getUserPermissionsActive: 'api/nomenclatoare/permission/list/active',
                    getUserPermissionsActivePublic:
                        'api/nomenclatoare/permission/list/public',
                    getUserPermission: 'api/nomenclatoare/permission/find/', // + id
                    changeStatusUserPermissionActive:
                        'api/nomenclatoare/permission/active/', // + id
                    changeStatusUserPermissionPublic:
                        'api/nomenclatoare/permission/public/', // + id
                    deleteUserPermission: 'api/nomenclatoare/permission/delete/', // + id
                    storeUserPermission: 'api/nomenclatoare/permission/store',
                },
                permissionActions: {
                    getPermissionActionsDT: 'api/nomenclatoare/permission-action/list-dt',
                    getPermissionActions: 'api/nomenclatoare/permission-action/list',
                    getPermissionActionsActive:
                        'api/nomenclatoare/permission-action/list/active',
                    getPermissionActionsActivePublic:
                        'api/nomenclatoare/permission-action/list/public',
                    getPermissionAction: 'api/nomenclatoare/permission-action/find/', // + id
                    putPermissionAction: 'api/nomenclatoare/permission-action/update',
                    changeStatusPermissionActionActive:
                        'api/nomenclatoare/permission-action/active/', // + id
                    changeStatusPermissionActionPublic:
                        'api/nomenclatoare/permission-action/public/', // + id
                    deletePermissionAction: 'api/nomenclatoare/permission-action/delete/', // + id
                    storePermissionAction: 'api/nomenclatoare/permission-action/store',
                },
                section: {
                    // sections from within the platform
                    getSections: 'api/nomenclatoare/section/list',
                    getSectionsActive: 'api/nomenclatoare/section/list/active',
                    getSectionsActivePublic: 'api/nomenclatoare/section/list/public',
                    getSection: 'api/nomenclatoare/section/find/', // + id
                    putSection: 'api/nomenclatoare/section/update', // id in payload
                    changeStatusSectionActive: 'api/nomenclatoare/section/active/', // + id
                    changeStatusSectionPublic: 'api/nomenclatoare/section/public/', // + id
                    deleteSection: 'api/nomenclatoare/section/delete/', // + id
                    storeSection: 'api/nomenclatoare/section/store',
                },
                functie: {
                    // functii operatori from the platform
                    getFunctii: 'api/nomenclatoare/functie/list',
                    getFunctiiDT: 'api/nomenclatoare/functie/list-dt',
                    getFunctiiActive: 'api/nomenclatoare/functie/list/active',
                    getFunctiiActivePublic: 'api/nomenclatoare/functie/list/public',
                    getFunctie: 'api/nomenclatoare/functie/find/', // + id
                    putFunctie: 'api/nomenclatoare/functie/update', // id in payload
                    changeStatusFunctieActive: 'api/nomenclatoare/functie/active/', // + id
                    changeStatusFunctiePublic: 'api/nomenclatoare/functie/public/', // + id
                    deleteFunctie: 'api/nomenclatoare/functie/delete/', // + id
                    storeFunctie: 'api/nomenclatoare/functie/store',
                },
                cerereSabloane: {
                    getCerereSabloaneDT: 'api/nomenclatoare/cerere-sabloane/list-dt',
                    getCerereSabloane: 'api/nomenclatoare/cerere-sabloane/list',
                    getCerereSablon: 'api/nomenclatoare/cerere-sabloane/find/', // + id
                    putCerereSablon: 'api/nomenclatoare/cerere-sabloane/update', // id in payload
                    deleteCerereSablon: 'api/nomenclatoare/cerere-sabloane/delete/', // + id
                    storeCerereSablon: 'api/nomenclatoare/cerere-sabloane/store',
                    getCerereSabloaneActive:
                        'api/nomenclatoare/cerere-sabloane/list/active',
                    getCerereSabloaneActivePublic:
                        'api/nomenclatoare/cerere-sabloane/list/public',
                    changeStatusCerereSablonActive:
                        'api/nomenclatoare/cerere-sabloane/active/', // + id
                    changeStatusCerereSablonPublic:
                        'api/nomenclatoare/cerere-sabloane/public/', // + id
                },
                client: {
                    // clients from the platform, not citizens.. which do we map our modules within clients
                    getClients: 'api/client/list',
                    getClientsDT: 'api/client/list-dt',
                    getClientsActive: 'api/client/list/active',
                    getClientsActivePublic: 'api/client/list/public',
                    getClient: 'api/client/find/', // + id
                    putClient: 'api/client/update', // id in payload
                    changeStatusClientActive: 'api/client/active/', // + id
                    changeStatusClientPublic: 'api/client/public/', // + id
                    deleteClient: 'api/client/delete/', // + id
                    storeClient: 'api/client/store',
                },
                citizen: {
                    // citizens
                    getCitizensDT: 'api/cetatean/list-dt',
                    getCitizen: 'api/cetatean/find/', // + id
                    updateCitizen: 'api/cetatean/update', // id in payload
                    postCitizenDeactivate: 'api/cetatean/deactivate-account', // id in payload
                    getCitizenVerificationHistory: 'api/cetatean/verification-history/', // + id
                    getCitizenHistory: 'api/cetatean/history/', // + id
                    getCitizenAddress: 'api/cetatean/address/', // + id
                    getCitizenAddressHistory: 'api/cetatean/address-history/', // + id
                    searchCitizen: 'api/cetatean/search',
                    searchCnp: 'api/cetatean/search-cnp',
                },
                inrolat: {
                    // inrolati from citizens
                    getInrolatiList: 'api/cetatean/inrolati/list',
                    getInrolatiDT: 'api/cetatean/inrolati/list-dt',
                    getInrolatiListActive: 'api/cetatean/inrolati/list-active',
                    getInrolat: 'api/cetatean/inrolati/find/', // + id
                    putInrolat: 'api/cetatean/inrolati/update', // id in payload
                    getShowPinInrolat: 'api/cetatean/inrolati/show-pin/', // + id
                    getInrolatAddress: 'api/cetatean/inrolati/address/', // + id
                    storeInrolat: 'api/cetatean/inrolati/store',
                },
                beneficiar: {
                    // beneficiari from citizens
                    getBeneficiariDT: 'api/cetatean/beneficiari/list-dt',
                    getBeneficiarAddress: 'api/cetatean/beneficiari/address/', // + id
                    getBeneficiarList: 'api/cetatean/beneficiari/list/', // + id
                    getBeneficiarListValidated: 'api/cetatean/beneficiari/list', // + id
                    postBeneficiarValidate: 'api/cetatean/beneficiari/validate/', // + id
                },
                recenzii: {
                    // recenzii from citizens
                    getRecenzii: 'api/recenzii',
                    getRecenziiSectiuni: 'api/recenzii-sectiuni',
                    markSpam: 'api/recenzii-mark-spam/', // + id
                    removeSpam: 'api/recenzii-remove-spam/', // + id
                },
                module: {
                    // activating modules to client
                    getModules: 'api/nomenclatoare/module/list',
                    getModulesActive: 'api/nomenclatoare/module/list/active',
                    getModulesActivePublic: 'api/nomenclatoare/module/list/public',
                    getModule: 'api/nomenclatoare/module/find/', // + id
                    putModule: 'api/nomenclatoare/module/update', // id in payload
                    changeStatusModuleActive: 'api/nomenclatoare/module/active/', // + id
                    changeStatusModulePublic: 'api/nomenclatoare/module/public/', // + id
                    deleteModule: 'api/nomenclatoare/module/delete/', // + id
                    storeModule: 'api/nomenclatoare/module/store',
                },
                directie: {
                    // directii from the platform
                    getDirectii: 'api/nomenclatoare/directie/list',
                    getDirectiiDT: 'api/nomenclatoare/directie/list-dt',
                    getDirectiiActive: 'api/nomenclatoare/directie/list/active',
                    getDirectiiActivePublic: 'api/nomenclatoare/directie/list/public',
                    getDirectie: 'api/nomenclatoare/directie/find/', // + id
                    putDirectie: 'api/nomenclatoare/directie/update', // id in payload
                    changeStatusDirectieActive: 'api/nomenclatoare/directie/active/', // + id
                    changeStatusDirectiePublic: 'api/nomenclatoare/directie/public/', // + id
                    deleteDirectie: 'api/nomenclatoare/directie/delete/', // + id
                    storeDirectie: 'api/nomenclatoare/directie/store',
                },
                compartiment: {
                    // compartimente(from directii) from the platform
                    getCompartimente: 'api/nomenclatoare/directie-compartiment/list',
                    getCompartimenteByDirectie:
                        'api/nomenclatoare/directie-compartiment/listByDirectie/',
                    getCompartimenteDT: 'api/nomenclatoare/directie-compartiment/list-dt',
                    getCompartimenteActive:
                        'api/nomenclatoare/directie-compartiment/list/active',
                    getCompartimenteActivePublic:
                        'api/nomenclatoare/directie-compartiment/list/public',
                    getCompartiment: 'api/nomenclatoare/directie-compartiment/find/', // + id
                    putCompartiment: 'api/nomenclatoare/directie-compartiment/update', // id in payload
                    changeStatusCompartimentActive:
                        'api/nomenclatoare/directie-compartiment/active/', // + id
                    changeStatusCompartimentPublic:
                        'api/nomenclatoare/directie-compartiment/public/', // + id
                    deleteCompartiment: 'api/nomenclatoare/directie-compartiment/delete/', // + id
                    storeCompartiment: 'api/nomenclatoare/directie-compartiment/store',
                },
                department: {
                    // departments from the platform
                    getDepartments: 'api/nomenclatoare/department/list',
                    getDepartmentsDT: 'api/nomenclatoare/department/list-dt',
                    getDepartmentsActive: 'api/nomenclatoare/department/list/active',
                    getDepartment: 'api/nomenclatoare/department/find/', // + id
                    putDepartment: 'api/nomenclatoare/department/update', // id in payload
                    changeStatusDepartmentActive: 'api/nomenclatoare/department/active/', // + id
                    deleteDepartment: 'api/nomenclatoare/department/delete/', // + id
                    storeDepartment: 'api/nomenclatoare/department/store',
                },
                imageType: {
                    // used to resize images to certain sizes
                    getImageTypesDT: 'api/nomenclatoare/image-type/list-dt',
                    getImageTypes: 'api/nomenclatoare/image-type/list',
                    getImageType: 'api/nomenclatoare/image-type/find/', // + id
                    storeImageType: 'api/nomenclatoare/image-type/store',
                    putImageType: 'api/nomenclatoare/image-type/update', // id in payload
                    deleteImageType: 'api/nomenclatoare/image-type/delete/', // + id
                },
                cerereType: {
                    getCerereTypesDT: 'api/nomenclatoare/cerere-type/list-dt',
                    getCerereTypes: 'api/nomenclatoare/cerere-type/list',
                    getCerereType: 'api/nomenclatoare/cerere-type/find/', // + id
                    putCerereType: 'api/nomenclatoare/cerere-type/update', // id in payload
                    deleteCerereType: 'api/nomenclatoare/cerere-type/delete/', // + id
                    storeCerereType: 'api/nomenclatoare/cerere-type/store',
                    getCerereTypesActive: 'api/nomenclatoare/cerere-type/list/active',
                    getCerereTypesActivePublic:
                        'api/nomenclatoare/cerere-type/list/public',
                    changeStatusCerereTypeActive: 'api/nomenclatoare/cerere-type/active/', // + id
                    changeStatusCerereTypePublic: 'api/nomenclatoare/cerere-type/public/', // + id
                },
                cerereStatus: {
                    getCerereStatusesDT: 'api/nomenclatoare/cerere-status/list-dt',
                    getCerereStatuses: 'api/nomenclatoare/cerere-status/list',
                    getCerereStatus: 'api/nomenclatoare/cerere-status/find/', // + id
                    putCerereStatus: 'api/nomenclatoare/cerere-status/update', // id in payload
                    deleteCerereStatus: 'api/nomenclatoare/cerere-status/delete/', // + id
                    storeCerereStatus: 'api/nomenclatoare/cerere-status/store',
                    getCerereStatusesActive:
                        'api/nomenclatoare/cerere-status/list/active',
                    getCerereStatusesActivePublic:
                        'api/nomenclatoare/cerere-status/list/public',
                    changeStatusCerereStatusActive:
                        'api/nomenclatoare/cerere-status/active/', // + id
                    changeStatusCerereStatusPublic:
                        'api/nomenclatoare/cerere-status/public/', // + id
                    updateOrder: 'api/nomenclatoare/cerere-status/update-order/', // + id => put request
                },
                cererePriority: {
                    getCererePrioritiesDT: 'api/nomenclatoare/cerere-priority/list-dt',
                    getCererePriorities: 'api/nomenclatoare/cerere-priority/list',
                    getCererePriority: 'api/nomenclatoare/cerere-priority/find/', // + id
                    putCererePriority: 'api/nomenclatoare/cerere-priority/update', // id in payload
                    deleteCererePriority: 'api/nomenclatoare/cerere-priority/delete/', // + id
                    storeCererePriority: 'api/nomenclatoare/cerere-priority/store',
                    getCererePrioritiesActive:
                        'api/nomenclatoare/cerere-priority/list/active',
                    getCererePrioritiesActivePublic:
                        'api/nomenclatoare/cerere-priority/list/public',
                    changeStatusCererePriorityActive:
                        'api/nomenclatoare/cerere-priority/active/', // + id
                    changeStatusCererePriorityPublic:
                        'api/nomenclatoare/cerere-priority/public/', // + id
                },
                platformSection: {
                    // sections to be displayed and grouped for cetateni. !!! ALSO. From this section, we can get all the next resources to show to operator. Content, FAQ, Announces
                    getPlatformSectionsDT: 'api/platform-section/list-dt',
                    getPlatformSections: 'api/platform-section/list',
                    getPlatformSection: 'api/platform-section/find/', // + id
                    putPlatformSection: 'api/platform-section/update', // id in payload
                    deletePlatformSection: 'api/platform-section/delete/', // + id
                    storePlatformSection: 'api/platform-section/store',
                    getPlatformSectionsActive: 'api/platform-section/list/active',
                    changeStatusPlatformSectionActive: 'api/platform-section/active/', // + id
                },
                platformFAQ: {
                    // frequently asked questions, for platform cetateni
                    getPlatformFAQsDT: 'api/platform-faq/list-dt',
                    getPlatformFAQs: 'api/platform-faq/list', // ?section_id={id}
                    getPlatformFAQ: 'api/platform-faq/find/', // + id
                    putPlatformFAQ: 'api/platform-faq/update', // id in payload
                    deletePlatformFAQ: 'api/platform-faq/delete/', // + id
                    storePlatformFAQ: 'api/platform-faq/store',
                    getPlatformFAQsActive: 'api/platform-faq/list/active', // ?section_id={id}
                    changeStatusPlatformFAQActive: 'api/platform-faq/active/', // + id
                    updateOrder: 'api/platform-faq/update-order/', // + id => put request
                },
                platformContent: {
                    // content for platform cetateni
                    getPlatformContentsDT: 'api/platform-content/list-dt',
                    getPlatformContents: 'api/platform-content/list', // ?section_id={id}
                    getPlatformContent: 'api/platform-content/find/', // + id
                    putPlatformContent: 'api/platform-content/update', // id in payload
                    deletePlatformContent: 'api/platform-content/delete/', // + id
                    storePlatformContent: 'api/platform-content/store',
                    getPlatformContentsActive: 'api/platform-content/list/active', // ?section_id={id}
                    changeStatusPlatformContentActive: 'api/platform-content/active/', // + id
                    updateOrder: 'api/platform-content/update-order/', // + id => put request
                },
                platformAnnounces: {
                    // announces for platform cetateni
                    getPlatformAnnouncesDT: 'api/platform-announces/list-dt',
                    getPlatformAnnounces: 'api/platform-announces/list', // ?section_id={id}
                    getPlatformAnnounce: 'api/platform-announces/find/', // + id
                    putPlatformAnnounce: 'api/platform-announces/update', // id in payload
                    deletePlatformAnnounce: 'api/platform-announces/delete/', // + id
                    storePlatformAnnounce: 'api/platform-announces/store',
                    getPlatformAnnouncesActive: 'api/platform-announces/list/active', // ?section_id={id}
                    changeStatusPlatformAnnounceActive: 'api/platform-announces/active/', // + id
                },
                tari: {
                    getTari: 'api/country/list',
                    getTariDT: 'api/country/list-dt',
                    getTariActive: 'api/country/list/active',
                    getTariPublic: 'api/country/list/public',
                    updateTari: 'api/country/update', // id in payload
                    changeStatusTariActive: 'api/country/active/', // + id
                    changeStatusTariPublic: 'api/country/public/', // + id
                    deleteTara: 'api/country/delete/', // + id
                    storeTara: 'api/country/store',
                },
                judete: {
                    getJudete: 'api/judet/list',
                    getJudeteDT: 'api/judet/list-dt',
                    getJudeteActive: 'api/judet/list/active',
                    getJudetePublic: 'api/judet/list/public',
                    updateJudete: 'api/judet/update', // id in payload
                    changeStatusJudeteActive: 'api/judet/active/', // + id
                    changeStatusJudetePublic: 'api/judet/public/', // + id
                    deleteJudet: 'api/judet/delete/', // + id
                    storejudet: 'api/judet/store',
                },
                localitati: {
                    getLocalitati: 'api/localitate/list',
                    getLocalitatiDT: 'api/localitate/list-dt',
                    getLocalitatiActive: 'api/localitate/list/active',
                    getLocalitatiPublic: 'api/localitate/list/public',
                    updateLocalitati: 'api/localitate/update', // id in payload
                    changeStatusLocalitatiActive: 'api/localitate/active/', // + id
                    changeStatusLocalitatiPublic: 'api/localitate/public/', // + id
                    deleteLocalitate: 'api/localitate/delete/', // + id
                    storeLocalitate: 'api/localitate/store',
                },
                strazi: {
                    getStrazi: 'api/strada/list',
                    getStraziDT: 'api/strada/list-dt',
                    getStraziActive: 'api/strada/list/active',
                    getStraziPublic: 'api/strada/list/public',
                    updateStrazi: 'api/strada/update', // id in payload
                    changeStatusStraziActive: 'api/strada/active/', // + id
                    changeStatusStraziPublic: 'api/strada/public/', // + id
                    deleteStrada: 'api/strada/delete/', // + id
                    storeStrada: 'api/strada/store',
                },
                crons: {
                    cronList: 'api/cron/list',
                    cronListDT: 'api/cron/list-dt',
                    cronActive: 'api/cron/list/active',
                    cronStore: 'api/cron/store',
                    cronUpdate: 'api/cron/update',
                    cronActivePut: 'api/cron/active/',
                    cronDelete: 'api/cron/delete/',
                },
                solicitareRank: {
                    list: 'api/cetatean/solicitare/rank/list',
                    listDT: 'api/cetatean/solicitare/rank/list-dt',
                    store: 'api/cetatean/solicitare/rank/store',
                    update: 'api/cetatean/solicitare/rank/update/',
                    delete: 'api/cetatean/solicitare/rank/delete/',
                    confirmationAccount: 'api/internalConfirmationCitizenAccount/',
                    find: 'api/cetatean/solicitare/rank/find/',
                },
                tipuriDocumente: {
                    getTipuriDocumenteDT: 'api/nomenclatoare/cetatean-documente-tipuri/list-dt',
                    getTipuriDocumente: 'api/nomenclatoare/cetatean-documente-tipuri/list',
                    getTipDocumente: 'api/nomenclatoare/cetatean-documente-tipuri/find/', // + id
                    putTipDocumente: 'api/nomenclatoare/cetatean-documente-tipuri/update', // id in payload
                    deleteTipDocumente: 'api/nomenclatoare/cetatean-documente-tipuri/delete/', // + id
                    storeTipDocumente: 'api/nomenclatoare/cetatean-documente-tipuri/store',
                    getTipuriDocumenteActive:
                        'api/nomenclatoare/cetatean-documente-tipuri/list/active',
                    changeStatusTipDocumenteActive:
                        'api/nomenclatoare/cetatean-documente-tipuri/active/', // + id
                },
                documenteCetatean: {
                    getDocumenteCetateanDT: 'api/citizen-documents/list-dt',
                    storeDocumentCetatean: 'api/citizen-documents/store',
                    updateDocumentCetatean: 'api/citizen-documents/update',
                    validateDocumentCetatean: 'api/citizen-documents/validate/', // + id
                    resetValidateDocumentCetatean: 'api/citizen-documents/rollback-validation/', // + id
                    cancelDocumentCetatean: 'api/citizen-documents/cancel/', // + id
                    resetCancelDocumentCetatean: 'api/citizen-documents/rollback-cancel/', // + id

                    addFiles: 'api/citizen-documents/add-files/', // + id
                    deleteFiles: 'api/citizen-documents/delete-files',

                    getHistory: 'api/citizen-documents/history/', // + id

                    confirmationDT: 'api/citizen-documents/confirmation/list-dt',
                    fileDownload: 'api/citizen-documents/download/', // + id_document/id_fisier
                    smsEmailDownload: 'api/citizen-documents/download-confirmation/', // + id_confirmare_document/type

                    getRaportDT: 'api/citizen-documents/reports/list-dt',
                    raportDownload: 'api/citizen-documents/reports/download',

                    getBorderouDT: 'api/citizen-documents/borderou/list-dt',
                    downloadPDF: 'api/citizen-documents/borderou/download-pdf/', // + id
                    downloadCSV: 'api/citizen-documents/borderou/download-csv/', // + id
                    searchDocuments: 'api/citizen-documents/search-documents',
                    generateBorderou: 'api/citizen-documents/generate-borderou',
                },
                ghiseulUnic: {
                    cerere: {
                        list: 'api/programari/cerere/list',
                        listDT: 'api/programari/cerere/list-dt',
                        find: 'api/programari/cerere/find/', // + id
                        store: 'api/programari/cerere/store-intern',

                        postMessage: 'api/programari/cerere/post-message/', // + id
                        rePostMessage: 'api/programari/cerere/re-post-message/', // + id
                        updateStatus: 'api/programari/cerere/update-status/', // + id
                        updatePriority: 'api/programari/cerere/update-priority/', // + id
                        updateAssignee: 'api/programari/cerere/update-asignee/', // + id
                        updateCetatean: 'api/programari/cerere/update-cetatean/', // + id - PUT
                        updateProgramareConfig: 'api/programari/cerere/update-programare-config/', // + id - PUT (tip problema/program)
                        reschedule: 'api/programari/cerere/reschedule/', // + id - POST (reprogramare)
                        validateCerere: 'api/programari/cerere/validate/', // + id
                        invalidateCerere: 'api/programari/cerere/invalidate/', // + id
                        anulareCerere: 'api/programari/cerere/anulare/', // + id
                        finalizareCerere: 'api/programari/cerere/finalize-cerere/', // + id
                        preluarePersonala: 'api/programari/cerere/preluare-cerere/', // + id
                        preluareNumarRegistratura: 'api/programari/cerere/generate-reg-number/', // + id

                        resetValidareCerere: 'api/programari/cerere/reset/validare/', // id_cerere - PUT
                        resetInvalidareCerere: 'api/programari/cerere/reset/invalidare/', // id_cerere - PUT
                        resetClasareCerere: 'api/programari/cerere/reset/clasare/', // id_cerere - PUT
                        resetInchidereCerere: 'api/programari/cerere/reset/finalizare/', // id_cerere - POST

                        // Prezență - Prezent/Absent
                        setPresent: 'api/programari/cerere/set-present/', // + id - POST
                        setAbsent: 'api/programari/cerere/set-absent/', // + id - POST
                        cancelSlotQuick: 'api/programari/cerere/cancel-slot-quick/', // + id - POST

                        // Reset Prezență
                        resetPresent: 'api/programari/cerere/reset-present/', // + id - POST
                        resetAbsent: 'api/programari/cerere/reset-absent/', // + id - POST
                        resetCancelSlot: 'api/programari/cerere/reset-cancel-slot/', // + id - POST
                        resetInvalidate: 'api/programari/cerere/reset-invalidate/', // + id - POST

                        downloadDocument: 'api/programari/cerere/download-document/', // + id
                        citizenHistory: 'api/programari/cerere/citizen-history/', // + id - GET (istoric programări cetățean)

                        file: {
                            fileUpload: 'api/programari/cerere/upload-file',
                            fileUploadBase64: 'api/programari/cerere/upload-file-base64',
                        },
                    },
                    notificari: {
                        email: {
                            getEmailDt: 'api/programari/email-notifications/list-dt',
                            downloadEmail: 'api/programari/email-notifications/view/', // + id
                            resendEmail: 'api/programari/email-notifications/resend/', // + id
                            printNotificari: 'api/programari/email-notifications/print',
                        },
                        sms: {
                            getSMSDt: 'api/programari/sms-notifications/list-dt',
                            resendSMS: 'api/programari/sms-notifications/resend/', // + id
                            printNotificari: 'api/programari/sms-notifications/print',
                        }
                    },
                    programari: {
                        listDT: 'api/programari/list-dt',
                        printList: 'api/programari/print-list',
                        exportExcel: 'api/programari/export-excel',
                        schedule: 'api/programari/schedule', // + id locatie activa in payload
                    },
                    prioritati: {
                        list: 'api/programari/priorities/list',
                        listDT: 'api/programari/priorities/list-dt',
                        listActive: 'api/programari/priorities/list/active',
                        listPublic: 'api/programari/priorities/list/public',
                        find: 'api/programari/priorities/find/', // + id
                        store: 'api/programari/priorities/store',
                        update: 'api/programari/priorities/update', // id in payload
                        delete: 'api/programari/priorities/delete/', // + id
                        active: 'api/programari/priorities/status/active/', // + id
                        public: 'api/programari/priorities/status/public/', // + id
                    },
                    status: {
                        list: 'api/programari/status/list',
                        listDT: 'api/programari/status/list-dt',
                        listActive: 'api/programari/status/list/active',
                        listPublic: 'api/programari/status/list/public',
                        find: 'api/programari/status/find/', // + id
                        store: 'api/programari/status/store',
                        update: 'api/programari/status/update', // id in payload
                        delete: 'api/programari/status/delete/', // + id
                        active: 'api/programari/status/status/active/', // + id
                        public: 'api/programari/status/status/public/', // + id
                        archive: 'api/programari/status/archive/', // + id
                        updateOrder: 'api/programari/status/order/', // + id => put request
                    },
                    zileLibere: {
                        getZileLibere: 'api/programari/nomenclatoare/zile/libere/list',
                        getZileLibereDT: 'api/programari/nomenclatoare/zile/libere/list-dt',
                        updateZiLibera: 'api/programari/nomenclatoare/zile/libere/update', // id in payload
                        deleteZiLibera: 'api/programari/nomenclatoare/zile/libere/delete/', // + id
                        storeZiLibera: 'api/programari/nomenclatoare/zile/libere/store',
                    },
                    module: {
                        getModul: 'api/programari/nomenclatoare/module/find/', // + id
                        getModule: 'api/programari/nomenclatoare/module/list',
                        getModuleDT: 'api/programari/nomenclatoare/module/list-dt',
                        getModuleActive: 'api/programari/nomenclatoare/module/list-active',
                        getModulePublic: 'api/programari/nomenclatoare/module/list-public-view',
                        updateModul: 'api/programari/nomenclatoare/module/update', // id in payload
                        deleteModul: 'api/programari/nomenclatoare/module/delete/', // + id
                        storeModul: 'api/programari/nomenclatoare/module/store',
                        changeStatusModulActive: 'api/programari/nomenclatoare/module/update-active/', // + id
                        changeStatusModulPublic: 'api/programari/nomenclatoare/module/update-public-view/', // + id
                        locatiiProgram: 'api/programari/nomenclatoare/module/advanced-edit/', // + id
                        moduleSloturi: 'api/programari/nomenclatoare/module/module-locatii-program/', // + id
                        advancedEdit: 'api/programari/nomenclatoare/module/module-advanced-edit',
                        moveUp: 'api/programari/nomenclatoare/module/move-up/', // + id => put request
                        moveDown: 'api/programari/nomenclatoare/module/move-down/', // + id => put request
                    },
                    locatii: {
                        getLocatii: 'api/programari/nomenclatoare/locatii/list',
                        getLocatiiDT: 'api/programari/nomenclatoare/locatii/list-dt',
                        getLocatiiActive: 'api/programari/nomenclatoare/locatii/list-active',
                        getLocatiiPublic: 'api/programari/nomenclatoare/locatii/list-public-view',
                        updateLocatie: 'api/programari/nomenclatoare/locatii/update', // id in payload
                        deleteLocatie: 'api/programari/nomenclatoare/locatii/delete/', // + id
                        storeLocatie: 'api/programari/nomenclatoare/locatii/store',
                        changeStatusLocatieActive: 'api/programari/nomenclatoare/locatii/update-active/', // + id
                        changeStatusLocatiePublic: 'api/programari/nomenclatoare/locatii/update-public-view/', // + id
                        getLocatieByModule: 'api/programari/nomenclatoare/locatii/find-by-module/', // + id
                    },
                    servicii: {
                        getServiciu: 'api/programari/nomenclatoare/servicii/find/', // + id
                        getServicii: 'api/programari/nomenclatoare/servicii/list',
                        getServiciiDT: 'api/programari/nomenclatoare/servicii/list-dt',
                        getServiciiActive: 'api/programari/nomenclatoare/servicii/list-active',
                        getServiciiPublic: 'api/programari/nomenclatoare/servicii/list-public-view',
                        updateServiciu: 'api/programari/nomenclatoare/servicii/update', // id in payload
                        deleteServiciu: 'api/programari/nomenclatoare/servicii/delete/', // + id
                        storeServiciu: 'api/programari/nomenclatoare/servicii/store',
                        changeStatusServiciuActive: 'api/programari/nomenclatoare/servicii/update-active/', // + id
                        changeStatusServiciuPublic: 'api/programari/nomenclatoare/servicii/update-public-view/', // + id
                    },
                    moduleLocatiiActive: {
                        getModuleLocatii: 'api/programari/nomenclatoare/module-locatii-active/list',
                        getModuleLocatiiDT: 'api/programari/nomenclatoare/module-locatii-active/list-dt',
                        updateModulLocatii: 'api/programari/nomenclatoare/module-locatii-active/update', // id in payload
                        deleteModulLocatii: 'api/programari/nomenclatoare/module-locatii-active/delete/', // + id
                        storeModulLocatii: 'api/programari/nomenclatoare/module-locatii-active/store',
                        moveUp: 'api/programari/nomenclatoare/module-locatii-active/move-up/', // + id => put request
                        moveDown: 'api/programari/nomenclatoare/module-locatii-active/move-down/', // + id => put request
                    },
                    locatiiServiciiActive: {
                        getLocatiiServicii: 'api/programari/nomenclatoare/locatii-servicii-active/list',
                        getLocatiiServiciiDT: 'api/programari/nomenclatoare/locatii-servicii-active/list-dt',
                        updateLocatieServicii: 'api/programari/nomenclatoare/locatii-servicii-active/update', // id in payload
                        deleteLocatieServicii: 'api/programari/nomenclatoare/locatii-servicii-active/delete/', // + id
                        storeLocatieServicii: 'api/programari/nomenclatoare/locatii-servicii-active/store',
                        moveUp: 'api/programari/nomenclatoare/locatii-servicii-active/move-up/', // + id => put request
                        moveDown: 'api/programari/nomenclatoare/locatii-servicii-active/move-down/', // + id => put request
                    },
                    moduleLocatiiServiciiActive: {
                        getModuleLocatiiServicii: 'api/programari/nomenclatoare/servicii-locatii-active/list',
                        getModuleLocatiiServiciiDT: 'api/programari/nomenclatoare/servicii-locatii-active/list-dt',
                        updateModulLocatiiServicii: 'api/programari/nomenclatoare/servicii-locatii-active/update', // id in payload
                        deleteModulLocatiiServicii: 'api/programari/nomenclatoare/servicii-locatii-active/delete/', // + id
                        storeModulLocatiiServicii: 'api/programari/nomenclatoare/servicii-locatii-active/store',
                        findByModule: 'api/programari/nomenclatoare/servicii-locatii-active/find-by-module/', // + id
                        moveUp: 'api/programari/nomenclatoare/servicii-locatii-active/move-up/', // + id => put request
                        moveDown: 'api/programari/nomenclatoare/servicii-locatii-active/move-down/', // + id => put request
                    },
                    programariSloturiBlocare: {
                        getProgramariSloturiBlocareDT: 'api/programari/nomenclatoare/servicii-slot-blocare/list-dt',
                        updateProgramareSloturiBlocare: 'api/programari/nomenclatoare/servicii-slot-blocare/update', // id in payload
                        deleteProgramareSloturiBlocare: 'api/programari/nomenclatoare/servicii-slot-blocare/delete/', // + id
                        storeProgramareSloturiBlocare: 'api/programari/nomenclatoare/servicii-slot-blocare/store',
                    },
                    programariSloturiUltimaOra: {
                        getProgramariSloturiUltimaOraDT: 'api/programari/nomenclatoare/ultima-ora-zi/list-dt',
                        updateProgramareSloturiUltimaOra: 'api/programari/nomenclatoare/ultima-ora-zi/update', // id in payload
                        deleteProgramareSloturiUltimaOra: 'api/programari/nomenclatoare/ultima-ora-zi/delete/', // + id
                        storeProgramareSloturiUltimaOra: 'api/programari/nomenclatoare/ultima-ora-zi/store',
                    },
                    tipProgram: {
                        getTipuriProgram: 'api/programari/nomenclatoare/tip-program/list',
                        getTipuriProgramDT: 'api/programari/nomenclatoare/tip-program/list-dt',
                        getTipuriProgramActive: 'api/programari/nomenclatoare/tip-program/list-active',
                        getTipuriProgramPublic: 'api/programari/nomenclatoare/tip-program/list-public-view',
                        updateTipProgram: 'api/programari/nomenclatoare/tip-program/update', // id in payload
                        deleteTipProgram: 'api/programari/nomenclatoare/tip-program/delete/', // + id
                        storeTipProgram: 'api/programari/nomenclatoare/tip-program/store',
                        changeStatusTipProgramActive: 'api/programari/nomenclatoare/tip-program/update-active/', // + id
                        changeStatusTipProgramPublic: 'api/programari/nomenclatoare/tip-program/update-public-view/', // + id
                    },
                    tipProgramActive: {
                        getTipuriProgramActive: 'api/programari/nomenclatoare/tip-program-activ-activ/list',
                        getTipuriProgramActiveDT: 'api/programari/nomenclatoare/tip-program-activ/list-dt',
                        updateTipProgramActive: 'api/programari/nomenclatoare/tip-program-activ/update', // id in payload
                        deleteTipProgramActive: 'api/programari/nomenclatoare/tip-program-activ/delete/', // + id
                        storeTipProgramActive: 'api/programari/nomenclatoare/tip-program-activ/store',
                        findByModule: 'api/programari/nomenclatoare/tip-program-activ/find-type-program-by-module/', // + id
                    },
                    operatori: {
                        getOperatori: 'api/programari/nomenclatoare/operatori/simple-list-module-users',
                        getOperatoriDT: 'api/programari/nomenclatoare/operatori/list-module-users',
                        getOperatoriFiltered: 'api/programari/nomenclatoare/operatori/list-filtered-users',
                        updateOperator: 'api/programari/nomenclatoare/operatori/update-module-locatii-servicii-permissions/', // + id
                        changeStatusOperatorActive: 'api/programari/nomenclatoare/operatori/update-active/', // + id
                        changeStatusOperatorPublic: 'api/programari/nomenclatoare/operatori/update-public-view/', // + id
                        getOperatorPermisiuniList: 'api/programari/nomenclatoare/operatori/operator-module-locatii-servicii-permissions/', // + id
                    },
                    users: {
                        getUsers: 'api/get-users-auth-core'
                    },
                    tipProblema: {
                        getTipuriProblema: 'api/programari/nomenclatoare/problem-type/list',
                        getTipuriProblemaDT: 'api/programari/nomenclatoare/problem-type/list-dt',
                        getTipuriProblemaActive: 'api/programari/nomenclatoare/problem-type/list-active',
                        getTipuriProblemaPublic: 'api/programari/nomenclatoare/problem-type/list-public-view',
                        updateTipProblema: 'api/programari/nomenclatoare/problem-type/update', // id in payload
                        deleteTipProblema: 'api/programari/nomenclatoare/problem-type/delete/', // + id
                        storeTipProblema: 'api/programari/nomenclatoare/problem-type/store',
                        changeStatusTipProblemaActive: 'api/programari/nomenclatoare/problem-type/update-active/', // + id
                        changeStatusTipProblemaPublic: 'api/programari/nomenclatoare/problem-type/update-public-view/', // + id
                    },
                    tipProblemaServiciiActive: {
                        getTipuriProblemaServiciiActive: 'api/programari/nomenclatoare/problem-types-servicii-active/list',
                        getTipuriProblemaServiciiActiveDT: 'api/programari/nomenclatoare/problem-types-servicii-active/list-dt',
                        updateTipProblemaServiciiActive: 'api/programari/nomenclatoare/problem-types-servicii-active/update', // id in payload
                        deleteTipProblemaServiciiActive: 'api/programari/nomenclatoare/problem-types-servicii-active/delete/', // + id
                        storeTipProblemaServiciiActive: 'api/programari/nomenclatoare/problem-types-servicii-active/store',
                        changeStatusTipProblemaServiciiActive: 'api/programari/nomenclatoare/problem-types-servicii-active/active/', // + id
                        changeStatusTipProblemaServiciiPublic: 'api/programari/nomenclatoare/problem-types-servicii-active/public/', // + id
                        moveUp: 'api/programari/nomenclatoare/problem-types-servicii-active/move-up/', // + id => put request
                        moveDown: 'api/programari/nomenclatoare/problem-types-servicii-active/move-down/', // + id => put request
                    },
                },
                documentePublice: {
                    getDocument: 'api/institutie/document/documents/find/', // + id
                    getDocumente: 'api/institutie/document/documents/list',
                    getDocumenteDT: 'api/institutie/document/documents/list-dt',
                    getDocumenteActive: 'api/institutie/document/documents/list/active',
                    getDocumentePublic: 'api/institutie/document/documents/list/public',
                    updateDocumente: 'api/institutie/document/documents/update', // id in payload
                    changeStatusDocumenteActive: 'api/institutie/document/documents/active/', // + id
                    changeStatusDocumentePublic: 'api/institutie/document/documents/public/', // + id
                    deleteDocument: 'api/institutie/document/documents/delete/', // + id
                    storeDocument: 'api/institutie/document/documents/store',
                    updateOrder: 'api/institutie/document/group/update-order/', // + id => put request
                    fileUpload: 'api/institutie/document/group/fileUpload/', // + id => put request
                },
                operatoriInstitutii: {
                    getOperator: 'api/institutie/document/operator/find/', // + id
                    getOperatori: 'api/institutie/document/operator/list',
                    getOperatoriDT: 'api/institutie/document/operator/list-dt',
                    getOperatoriActive: 'api/institutie/document/operator/list/active',
                    getOperatoriPublic: 'api/institutie/document/operator/list/public',
                    updateOperator: 'api/institutie/document/operator/update', // id in payload
                    changeStatusOperatorActive: 'api/document/institutie/operator/active/', // + id
                    changeStatusOperatorPublic: 'api/document/institutie/operator/public/', // + id
                    deleteOperator: 'api/institutie/document/operator/delete/', // + id
                    storeOperator: 'api/institutie/document/operator/store',
                },
                ani: {
                    getAn: 'api/institutie/document/year/find/', // + id
                    getAni: 'api/institutie/document/year/list',
                    getAniDT: 'api/institutie/document/year/list-dt',
                    getAniActive: 'api/institutie/document/year/list/active',
                    getAniPublic: 'api/institutie/document/year/list/public',
                    updateAni: 'api/institutie/document/year/update', // id in payload
                    changeStatusAniActive: 'api/institutie/document/year/active/', // + id
                    changeStatusAniPublic: 'api/institutie/document/year/public/', // + id
                    deleteAn: 'api/institutie/document/year/delete/', // + id
                    storeAn: 'api/institutie/document/year/store',
                },
                categoriiDocumente: {
                    getCategorie: 'api/institutie/document/group/find/', // + id
                    getCategorii: 'api/institutie/document/group/list',
                    getCategoriiDT: 'api/institutie/document/group/list-dt',
                    getCategoriiActive: 'api/institutie/document/group/list/active',
                    getCategoriiPublic: 'api/institutie/document/group/list/public',
                    updateCategorii: 'api/institutie/document/group/update', // id in payload
                    changeStatusCategoriiActive: 'api/institutie/document/group/active/', // + id
                    changeStatusCategoriiPublic: 'api/institutie/document/group/public/', // + id
                    deleteCategorie: 'api/institutie/document/group/delete/', // + id
                    storeCategorie: 'api/institutie/document/group/store',
                    updateOrder: 'api/institutie/document/group/update-order/', // + id => put request
                },
                tipuriDocumenteInstitutii: {
                    getTip: 'api/institutie/document/type/find/', // + id
                    getTipuri: 'api/institutie/document/type/list',
                    getTipuriDT: 'api/institutie/document/type/list-dt',
                    getTipuriActive: 'api/institutie/document/type/list/active',
                    getTipuriPublic: 'api/institutie/document/type/list/public',
                    updateTipuri: 'api/institutie/document/type/update', // id in payload
                    changeStatusTipuriActive: 'api/institutie/document/type/active/', // + id
                    changeStatusTipuriPublic: 'api/institutie/document/type/public/', // + id
                    deleteTip: 'api/institutie/document/type/delete/', // + id
                    storeTip: 'api/institutie/document/type/store',
                    updateOrder: 'api/institutie/document/group/update-order/', // + id => put request
                },
                sectiuniPublice: {
                    getSectiune: 'api/institutie/document/group-public/find/', // + id
                    getSectiuniDT: 'api/institutie/document/group-public/list-dt',
                    updateSectiuni: 'api/institutie/document/group-public/update', // id in payload
                    changeStatusSectiuniActive: 'api/institutie/document/group-public/active/', // + id
                    changeStatusSectiuniPublic: 'api/institutie/document/group-public/public/', // + id
                    deleteSectiune: 'api/institutie/document/group-public/delete/', // + id
                    storeSectiune: 'api/institutie/document/group-public/store',
                },
            },
        },
        clients: {
            contacts: {
                getContacts: 'api/client/contact/list',
                getContactById: 'api/client/contact/find/',
                getContactsDT: 'api/client/contact/list-dt',
                getContactsActive: 'api/client/contact/list/active',
                getContactsPublic: 'api/client/contact/list/public',
                updateContact: 'api/client/contact/update',
                changeStatusContactActive: 'api/client/contact/active/',
                changeStatusContactPublic: 'api/client/contact/public/',
                deleteContact: 'api/client/contact/delete/',
                storeContact: 'api/client/contact/store',
            },
            modules: {
                getClientModulesDT: 'api/client/module/list-dt',
                storeClientModule: 'api/client/module/store',
                changeStatusContactActive: 'api/client/module/active/',
                deleteClientModule: 'api/client/module/delete/',
                getClientModulesByClient: 'api/client/module/listByClient/',
                getClientModuleById: 'api/client/module/find/',
                updateClientModule: 'api/client/module/update',
                getUserClientModules: 'api/client/module/user/getUserClientModules',
                updateOrder: 'api/client/module/updateOrder/',
            },
            operators: {
                getClientOperatorsDT: 'api/client/module/user/list-dt',
                getUsersByClientAndModule:
                    'api/client/module/user/getUsersByClientModule/', //client_id/module_id/active (-1, 0, 1)
                storeClientOperator: 'api/client/module/user/store',
                massStoreClientOperators: 'api/client/module/user/massStore',
                deleteClientOperator: 'api/client/module/user/delete/',
            },
            permissions: {
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/', // + id_client/id_module
                listUserPermissions:
                    'api/client/module/permission/user/listUserPermissions',
                updateAssignedPermissionUser:
                    'api/client/module/permission/user/updateAssignedPermissionUser',
            },
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve --configuration=development --port=4100
 */
